import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router'
import { Link } from 'react-router-dom';
import FormAgregar from '../../components/asignaturas/FormAgregar';
import TemaRow from '../../components/asignaturas/TemaRow';
import Layout from '../../components/layout/Layout'
import { getAsignaturaId, updateNumberTemas } from '../../helpers/asignaturas';
import { createTema } from '../../helpers/temas';
import { useForm } from '../../hooks/ useForm';
import { refreshthemes } from '../../reducer/AsignaturasReducer';
import { startLoadTemas, startNewTema } from '../../reducer/TemasReducer';

const AsignaturaIdView = () => {
    const { email } = useSelector(state => state.perfil)
    const {temas} = useSelector(state => state.temas)
    const dispatch = useDispatch()
    const [error, setError] = useState(false)
    const [message, setMessage] = useState('')
    const [loading, setLoading] = useState(false)
    const [loadThemes, setLoadThemes] = useState(false)
    const [value, handleInputChange, reset] = useForm({name: ''})
    const [dataAsig, setDataAsig] = useState();
    const {idAsig} = useParams();
    const { asignaturas } = useSelector(state => state.asignaturas);
    const asignatura = useMemo(() => getAsignaturaId(idAsig,asignaturas), [idAsig, asignaturas])
    useEffect(() => {
        asignatura.then(data => {
            setDataAsig(data)
        });
        dispatch(startLoadTemas(email, idAsig))
        return () => {
            setDataAsig()
        }
    }, [asignatura, dispatch, idAsig, email])

    const isFormValid = (name) =>{
        if (name.trim().length === 0) {
            setError(true)
            setMessage('Nombre del tema es requerido')
            return false
        }
        return true;
    }
    
    const handleSubmit = (name) => {
        setLoading(true)
        if (!isFormValid(name)) {
            return 
        }
        var fecha = new Date().getTime();
        createTema(email,idAsig,name,fecha)
        .then(() => {
            dispatch(startNewTema(idAsig,name,fecha))
            setLoading(false)
            dispatch(refreshthemes(idAsig,dataAsig?.themes+1))
            updateNumberTemas(email,idAsig,dataAsig.themes+1)
            reset()
        })
        .catch(e => console.log(e))
    }

    useEffect(() => {
        setLoadThemes(true)
        setTimeout(() => {
            setLoadThemes(false)
        }, 2000);
        return () => {  }
    }, [idAsig])
    
    return (
        <Layout>
            <h1 className='title'>{dataAsig?.nameSubject}</h1>
            <FormAgregar
                error={error}
                message={message}
                loading={loading}
                funcion={handleSubmit}
                value={value}
                change={handleInputChange}
                placeholder='Nombre del tema'
            />
            <div className='controls-return-left'>
                <Link
                    to={`/progress/asignatura/${idAsig}/${dataAsig?.nameSubject}`}
                    className="btn far fa-eye"
                > progreso
                </Link>

            </div>
            <table className='table_tema'>
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Tema</th>
                        <th colSpan='2'>Acción</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loadThemes
                        ?<tr><td colSpan='3'><div className="lds-ripple"><div></div><div></div></div></td></tr>
                        :
                        temas?.length === 0 
                        ?   <tr>
                                <td colSpan='3'>Cargando o no hay temas</td>
                            </tr>
                        :
                        temas?.map((tema, index) => (
                            <TemaRow
                                key={index}
                                number={index+1}
                                idAsig={idAsig}
                                idTema={tema.id}
                                nombreTema={tema.name}
                                date={tema.date}
                                numThems={dataAsig?.themes}
                            />
                        ))
                    }
                </tbody>
            </table>
        </Layout>
    )
}

export default AsignaturaIdView
